import { faChevronRight, faPlus } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Tooltip } from '@mui/material';
import { useContext } from 'react';

import Utils from '../../../../utils/immersive_utils';
import { BacktestingContext } from '../../../../providers/backtesting/backtesting-provider';
import { StrategyTab } from '../../../../providers/backtesting/types';

import './styles.scss';

const MAX_LABEL_LENGTH = 50;

export const StrategySidebar = () => {
  const { activeBacktestId, getActiveBacktest, setActiveStrategy, addStrategy } =
    useContext(BacktestingContext);

  const activeBacktest = getActiveBacktest();
  if (!activeBacktest || !activeBacktestId) return null;

  const { strategies, activeStrategyId } = activeBacktest;

  const handleStrategyClick = (strategy: StrategyTab) => {
    setActiveStrategy(activeBacktestId, strategy.id);
  };

  const handleCreateNew = () => {
    addStrategy(activeBacktestId);
  };

  return (
    <div className="strategy-sidebar">
      <div className="strategy-sidebar-label">Or Create Your Own</div>

      <div className="strategy-sidebar-list">
        {strategies.map((strategy) => {
          const isActive = strategy.id === activeStrategyId;
          return (
            <Tooltip
              key={strategy.id}
              title={strategy.label.length >= MAX_LABEL_LENGTH ? strategy.label : ''}
            >
              <div
                className={`strategy-sidebar-item ${isActive ? 'active' : ''} ${strategy.hasError ? 'error' : ''}`}
                onClick={() => handleStrategyClick(strategy)}
              >
                <span className="strategy-sidebar-item-label">
                  {Utils.truncateLabel(strategy.label, MAX_LABEL_LENGTH)}
                </span>

                <FontAwesomeIcon
                  icon={faChevronRight}
                  className="strategy-sidebar-item-indicator"
                />
              </div>
            </Tooltip>
          );
        })}
      </div>

      <Button className="btn-create-strategy" onClick={handleCreateNew}>
        <FontAwesomeIcon icon={faPlus} />
        <span>Create New Strategy</span>
      </Button>
    </div>
  );
};
